import useApi from "./useApi";

const useLoginDetailEmployee = (page = 1, perPage = 20) => {
  const { get } = useApi();
  // Add pagination query params
  const url = `/employee-login-details?page=${page}&per_page=${perPage}`;
  const query = get(url);
  return query;
};

export default useLoginDetailEmployee; 